module.exports = __webpack_public_path__ + "img/horizontal_4_1_5012.634d9a10.png";